import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-result-station-and-platform.scss',
  tag: 'paf-result-station-and-platform',
})

export class PafResultStationAndPlatform implements ComponentInterface {

  /**
   * The name of the station.
   */
  @Prop() public stationName!: string;

  /**
   * The platform from where the
   * service is leaving or arriving
   */
  @Prop() public platform!: string;

  /**
   * If set to true, the platformChange
   * property will set an additional class
   * to give the customer a visual indication
   * of the platform change.
   * */
  @Prop() public platformChange!: boolean;

  public render(): HTMLDivElement {
    return (
      <p class='timetable-leg__station_and_platform'>
        <span class='timetable-leg__station'>
          {this.stationName}
        </span>
        <span
          class={{
            'timetable-leg__platform': true,
            'timetable-leg__platform--changed': this.platformChange,
          }}
        >
          {this.platform}
        </span>
      </p>
    );
  }
}
